/**
 * 子ども医療証（マル子）のフロント共通の定数・型。
 *
 * 子ども医療証は汎用の各種書類（additionalDocuments）と同じ仕組みで保存しつつ、
 * 種別（shared_back の `AdditionalDocumentType.ChildMedicalCertificate`）で分離する。
 * おもて/うらの 2 枚は additionalDocuments の `order` で区別する。
 *
 * patient（マイページ #2577・予約フロー #2581）/ clinic（診療詳細 #2578）双方で
 * 再利用するため shared_front に置く。
 *
 * `domain/index.ts` で `export * as ChildMedicalCertificate` 経由で公開されるため、
 * 利用側からは `ChildMedicalCertificate.ORDER.front` のように参照される。
 */
/** 子ども医療証の面（おもて / うら）。 */
export const SIDE = {
    Front: "front",
    Back: "back",
};
/** おもて/うらに対応する additionalDocuments の `order`。 */
export const ORDER = {
    front: 0,
    back: 1,
};
